export interface PersonalProfile {
  phone?: string;
  address?: string;
  city?: string;
  country?: string;
  pincode?: string;
}

export interface CompanyProfile {
  companyName?: string;
  companyPhone?: string;
  companyEmail?: string;
  companyAddress?: string;
  taxId?: string;
  website?: string;
  youtubeLink?: string;
  linkedInLink?: string;
  instgramLink?: string;
}

export interface User {
  sub: string;
  name: string;
  email: string;
  picture: string;
  personal?: PersonalProfile;
  company?: CompanyProfile;
}

export interface AuthContextType {
  user: User | null;
  login: (credential: string) => void;
  logout: () => void;
  loading: boolean;
  openAuthModal: () => void; // ✅ ADD
  closeAuthModal: () => void; // ✅ ADD
  isAuthModalOpen: boolean; // ✅ ADD
}

export const getProfileCompletion = (): number => {
  const stored = localStorage.getItem("user_profile");
  if (!stored) return 20; // only Google login = 20%

  const profile = JSON.parse(stored);

  let filled = 0;
  const totalFields = 4;

  if (profile.phone) filled++;
  if (profile.address) filled++;
  if (profile.companyName) filled++;
  if (profile.companyAddress) filled++;

  return 20 + Math.floor((filled / totalFields) * 80);
};

export const dotnetAPIBaseURL =
  "https://socialmediawebappdotnet-c5gvgzgqauekgmej.westindia-01.azurewebsites.net";
